export default __webpack_public_path__ + "static/tree-cameraRaw-burn-h348-452f583b3f9f98b5ff2e35059b8f1cb2.png";